import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { User } from 'src/app/shared/model/user';
import { UserApiService } from '../../../service/user-api.service';
import { AlertService } from 'src/app/shared/service/alert.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomainFinderApiService } from '../../../../../shared/service/domain-finder-api.service';
import { DomainNames } from 'src/app/shared/enum/domain-names.enum';
import { Domain } from 'src/app/shared/model/domain';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html'
})
export class UserFormComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();

  @Input()
  public user: User;
  public formGroup: FormGroup;
  public indentificationTypes: Array<Domain>

  constructor(private userApiService: UserApiService,
    private alertService: AlertService,
    public activeModal: NgbActiveModal,
    private domainApiService: DomainFinderApiService
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.findIdentificationTypes();
  }

  ngOnDestroy(): void {
    this.formGroup.reset();
    this.user = null;
    this.subscription.unsubscribe();
  }

  private initForm() {

    this.formGroup = new FormGroup({
      identificationType: new FormControl(this.user?.identificationType, [Validators.required]),
      identificationNumber: new FormControl(this.user?.identificationNumber, [Validators.required]),
      name: new FormControl(this.user?.name, [Validators.required]),
      lastName: new FormControl(this.user?.lastName, [Validators.required]),
      phone: new FormControl(this.user?.phone, [Validators.required]),
      password: new FormControl(this.user?.password, [Validators.required]),
      password2: new FormControl(this.user?.password, [Validators.required]),
      sex: new FormControl(this.user?.sex, [Validators.required]),
      email: new FormControl(this.user?.email, [Validators.required, Validators.email]),
      active: new FormControl(this.user?.active, [Validators.required])
    });
    this.formGroup.setValidators(this.checkPasswords);
  }

  private findIdentificationTypes() {
    this.domainApiService.findActivesByName(DomainNames.IDENTIFICATION_TYPE).subscribe(resp => {
      this.indentificationTypes = resp;
    })
  }

  private checkPasswords(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('password2')?.value;
    if (password && confirmPassword) {
      const equals = password === confirmPassword;
      if (!equals) {
        group.get('password').setErrors({ 'required': true });
        group.get('password2').setErrors({ 'required': true });
      } else {
        group.get('password').setErrors(null)
        group.get('password2').setErrors(null)
      }
      return equals ? null : { notSame: true };
    } else {
      return null;
    }
  }

  public get controls() {
    return this.formGroup.controls;
  }

  public onSave() {
    console.log('this.formGroup ', this.formGroup);
    if (this.formGroup.invalid) {
      return;
    }
    const user = this.formGroup.getRawValue();
    if (this.user) {
      this.update(user);
    } else {
      this.save(user);
    }
  }

  private save(user: User) {
    const sub = this.userApiService.save(user).subscribe(() => {
      this.alertService.showSuccessful('Se ha creado el usuario correctamente', 'Creado exito!');
      this.user = null;
      this.activeModal.close(true);
    });
    this.subscription.add(sub);
  }

  private update(user: User) {
    const sub = this.userApiService.edit(this.user.id, user).subscribe(() => {
      this.alertService.showSuccessful('Se ha actualizado el usuario correctamente', 'Actualizado exito!');
      this.user = null;
      this.activeModal.close(true);
    });
    this.subscription.add(sub);
  }

}
